import { ITableConfig } from '@devinforius/super-compos-17';

/**
 * @deprecated This class has to be replaced by {@link TableConfig} from `@devinforius/i-table` and its factory `TableConfigFactory`.
 * BaseTableConfig is a base configuration for tables in the application.
 * It uses {@link ITableConfig} as its base and provides default values for common table configurations.
 */
export class BaseTableConfig extends ITableConfig {
  constructor() {
    super();
    this.responsive = true;
    this.showPaginator = true;
    this.showForSelectionRow = false;
    this.showColumnSelector = false;
    this.isRowClickable = false;
    this.showAdvancedSearch = false;
    this.multiselect = false;
    this.showFastSearch = false;
    this.selectionActions = {
      remove: false,
      export: false,
    };
  }

  public withClickableRows(): BaseTableConfig {
    this.isRowClickable = true;
    return this;
  }

  public withCheckableRows(availableActions: { delete?: boolean; export?: boolean }): BaseTableConfig {
    this.multiselect = true;
    this.showForSelectionRow = true;

    if (availableActions.delete) {
      this.withDeletableRows();
    }
    if (availableActions.export) {
      this.withExportableRows();
    }

    return this;
  }

  public withDeletableRows(): BaseTableConfig {
    this.selectionActions.remove = true;
    return this;
  }

  public withExportableRows(): BaseTableConfig {
    this.selectionActions.export = true;
    return this;
  }
}
